import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-text-[15px] tw-text-[#231F20] tw-mt-[-10px]" }
const _hoisted_2 = { class: "tw-relative" }
const _hoisted_3 = { class: "tw-p-[10px] tw-text-[13px] tw-font-[400] tw-text-[#231F20] tw-font-Poppins" }
const _hoisted_4 = { class: "tw-flex" }

import { computed, PropType, ref, watch } from "vue";
import AreYouSureModal from "@/components/recommend/areYouSureModal.vue";
import { getComponentUiText } from "@/utils/utilities";
import BaseInput from "../common/form/baseInput.vue";
import { helpers, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import store from "@/store";
import { CHECKLISTSTATUS } from "@/utils/constants";
import DatePickInput from "../common/datePickInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'modalCompleteAssessment',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  checklistParentId: {
    type: Number,
    required: true,
  },
  updateDataFunction: {
    type: Function as PropType<(payload: any) => Promise<void>>,
    required: false,
    default: undefined,
  },
},
  emits: ["update:show", "update:data"],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);

const styleClassContain = ref({
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
  "z-index": "2222",
  overflow: "unset !important",
});

const parentNote = computed(() => {
  let checklistNote = "";
  const data = store.getters["Assessment/getChecklistAssessment"];
  const checklist = data.find((e) => e.checklistId === props.checklistParentId)
    ?.checklistAssessmentHistory;

  checklist.forEach((element) => {
    if (
      element.checklistStatusNotes &&
      !checklistNote &&
      element.checklistStatusId === CHECKLISTSTATUS.DONE
    ) {
      checklistNote = element.checklistStatusNotes;
      form.value.note = checklistNote;
    }
  });

  return checklistNote;
});

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const rules = {
  note: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  checklistReportingDate: {},
};

const form = ref<any>({ note: "", checklistReportingDate: "" });

let v$ = useVuelidate(rules, form);



const handleUpdateShow = (value) => {
  showRef.value = value;
  emit("update:show", showRef.value);
};

const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleUpdateData = async () => {
  await v$.value.$validate();

  if (v$.value.$invalid) return false;

  if (props.updateDataFunction) {
    await props.updateDataFunction(form.value);
    handleCloseModal();
  } else {
    emit("update:data", form.value);
    handleCloseModal();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AreYouSureModal, {
    show: _unref(showRef),
    title: 
      _unref(getComponentUiText)(
        'app-component-assessment-modal-complete-assesment-title-1',
      )
    ,
    description: 
      _unref(getComponentUiText)(
        'app-component-assessment-modal-complete-assesment-description-1',
      )
    ,
    "button-text": 
      _unref(getComponentUiText)(
        'app-component-assessment-modal-complete-assesment-title-1',
      )
    ,
    "button-red": false,
    "hidden-help": false,
    "is-validate": true,
    "max-width": 40,
    "update-data-function": handleUpdateData,
    "style-class-contain": styleClassContain.value,
    "onUpdate:show": handleUpdateShow,
    "onUpdate:data": handleUpdateData
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(getComponentUiText)(
          "app-component-assessment-modal-complete-assesment-description-note-1",
        )) + " ", 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseInput, {
          modelValue: form.value.note,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.note) = $event)),
          required: true,
          validation: _unref(v$).note,
          "validate-on-blur": true,
          type: 'text',
          "col-title": 4,
          "col-input": 8,
          label: 
          _unref(getComponentUiText)(
            'app-component-assessment-modal-complete-assesment-label-note-1',
          )
        ,
          placeholder: 
          _unref(getComponentUiText)(
            'app-component-assessment-modal-complete-assesment-placeholder-note-1',
          )
        ,
          "class-name": '!tw-items-center',
          "data-cy-id": "modal-complete-assessment-note"
        }, {
          rightInput: _withCtx(() => [
            (parentNote.value)
              ? (_openBlock(), _createBlock(ButtonShowDuplicateAssessment, {
                  key: 0,
                  "id-popover": 'popover-modal-complete-assessment',
                  "custom-class": 'tw-max-w-[290px]',
                  classes: `tw-leading-[36px] tw-w-[25px] tw-items-center tw-flex tw-justify-center`,
                  placement: 'bottom-end'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-modal-complete-assesment-tooltip-note-1",
                )), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "validation", "label", "placeholder"]),
        _createVNode(BaseInput, {
          id: "name",
          modelValue: form.value.checklistReportingDate,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.checklistReportingDate) = $event)),
          validation: _unref(v$).checklistReportingDate,
          "col-title": 4,
          "col-input": 8,
          label: 
          _unref(getComponentUiText)(
            'app-component-assessment-modal-complete-assesment-field-label-report-date-1',
          )
        ,
          placeholder: 
          _unref(getComponentUiText)(
            'app-component-assessment-modal-complete-assesment-placeholder-report-date-1',
          )
        ,
          "class-name": '!tw-items-center'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(DatePickInput, {
                modelValue: form.value.checklistReportingDate,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((form.value.checklistReportingDate) = $event)),
                  _cache[2] || (_cache[2] = 
              (value) => (value ? (form.value.checklistReportingDate = value) : '')
            )
                ],
                placeholder: 
              _unref(getComponentUiText)(
                'app-component-assessment-modal-complete-assesment-placeholder-report-date-1',
              )
            ,
                disabled: false,
                "class-name": `tw-w-full`,
                "data-cy-id": "modal-complete-assessment-reporting-date",
                focus: true,
                "custom-input-class": `tw-flex tw-flex-1 ${
              parentNote.value ? 'tw-mr-[32px]' : ''
            }`,
                validation: _unref(v$).checklistReportingDate
              }, null, 8, ["modelValue", "placeholder", "custom-input-class", "validation"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "validation", "label", "placeholder"])
      ])
    ]),
    _: 1
  }, 8, ["show", "title", "description", "button-text", "style-class-contain"]))
}
}

})